import { gql } from '@apollo/client';

/**
 * Deleting a translation leaves its norm set alone — the cascade runs the other
 * way, so removing the parent removes its translations.
 */
export default gql`
  mutation DeletePerceptionModelProjectTranslation($id: Int!) {
    deletePerceptionModelProjectTranslationById(input: { id: $id }) {
      deletedPerceptionModelProjectTranslationId
    }
  }
`;
